import type { PrybarTheme } from "@prybar/core";
import type { ResolvedTheme } from "../lib/theme";

// Prybar renders part of its UI into an iframe document that cannot see our
// CSS variables, so the theme has to carry resolved colours. They are read
// from the live tokens rather than written here, which keeps the command bar
// on whichever colour theme the member has chosen.
function token(style: CSSStyleDeclaration, name: string): string {
  return style.getPropertyValue(name).trim();
}

function alpha(color: string, pct: number): string {
  return `color-mix(in srgb, ${color} ${pct}%, transparent)`;
}

export function healthOsPrybarTheme(scheme: ResolvedTheme): Partial<PrybarTheme> {
  if (typeof document === "undefined") return { colorScheme: scheme };
  const style = getComputedStyle(document.documentElement);
  const accent = token(style, "--color-ink-brand-light");
  const ink = token(style, "--color-ink-primary");
  return {
    accentColor: accent,
    accentColorMuted: alpha(accent, 10),
    textColor: ink,
    textMuted: alpha(ink, 55),
    panelBackground: alpha(token(style, "--color-surface-elevated"), 98),
    overlayBackground: alpha(token(style, "--color-navy-deep"), 10),
    borderColor: alpha(accent, 20),
    fontFamily: token(style, "--font-sans"),
    colorScheme: scheme,
  };
}
